import { useMemo } from 'react';
import { MCPServerConfig } from '../types';
import { getDefaultMcpServers } from '../services/aiService';

export interface GameConfig {
  mcpServers: MCPServerConfig[];
}

/**
 * Hook providing game configuration (MCP servers).
 *
 * System prompt is now loaded from R2 by the AI service (single source of truth).
 * Previously this hook provided a hardcoded prompt which caused stale prompt issues.
 *
 * Usage:
 * ```tsx
 * const { mcpServers } = useGameConfig();
 * const { messages, sendMessage } = useChat({ mcpServers });
 * ```
 */
export function useGameConfig(): GameConfig {
  // MCP servers are computed dynamically based on current hostname
  const mcpServers = useMemo(() => getDefaultMcpServers(), []);

  return useMemo(() => ({
    mcpServers,
  }), [mcpServers]);
}
